import { HubConnectionBuilder, HubConnection, LogLevel } from '@microsoft/signalr';
import { msalAuthenticator } from '../accounts/auth';

export abstract class SignalRService {
  protected connection: HubConnection;
  private reconnecting: boolean = false;
  private onReconnectedCallbacks: Array<() => void> = [];

  constructor(url: string) {
    this.connection = new HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory: this.getAccessToken
      })
      .configureLogging(LogLevel.None)
      .withAutomaticReconnect()
      .build();

      this.connection.onreconnecting((error) => {
        console.warn('SignalR Reconnecting due to error:', error);
        this.reconnecting = true;
      });
  
      this.connection.onreconnected((connectionId) => {
        console.log('SignalR Reconnected with connection ID:', connectionId);
        this.reconnecting = false;
        this.notifyReconnected();
      });
  
      this.connection.onclose((error) => {
        console.error('SignalR Connection closed due to error:', error);
        this.reconnecting = false;
        this.start();
      });

      this.Initialize();
  }

  protected abstract Initialize() : void;

  async getAccessToken() : Promise<string> {
    const token = await msalAuthenticator.getToken();
    return token ?? '';
  }
  
  public async start(): Promise<void> {
    try {
      await this.connection.start();

      console.log('connnected : ', this.connection.connectionId);
    } catch (err) {
      console.error('SignalR Connection Error: ', err);
    }
  }

  public on(eventName: string, callback: (...args: any[]) => void) {
    this.connection.on(eventName, callback);
  }

  public async send(eventName: string, ...args: any[]) {
    try {
      await this.connection.send(eventName, ...args);
    } catch (err) {
      console.error('SignalR Send Error: ', err);
    }
  }

  public async stop(): Promise<void> {
    try {
      await this.connection.stop();
      console.log('SignalR Disconnected.');
    } catch (err) {
      console.error('SignalR Disconnect Error: ', err);
    }
  }

  public getConnection() {
    return this.connection;
  }

  private notifyReconnected() {
    this.onReconnectedCallbacks.forEach(callback => callback());
  }

  public onReconnected(callback: () => void) {
    this.onReconnectedCallbacks.push(callback);
  }
}
